import "./radioUI.scss";

export const RadioUI = ({ value, checked, onChange }) => {
  return (
    <label className="radio-ui">
      <input
        type="radio"
        className="radio-ui__input"
        value={value}
        checked={checked}
        onChange={onChange}
      />
      <span className="radio-ui__circle" />
    </label>
  );
};
